<template>
  <div class="haffner-page">
    <div class="loading-spinner-outer" v-if="sending">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="landing-page-introduction-box">
      <div class="title">
        <div>
          Exclusive offer with Haffner
        </div>
        <div class="logo">
          <img src="/images/powered-by-logo-haffner.png">
        </div>
      </div>
      <div class="highlight-bar">
        <h1>Get 2 free service visits a year across all new machines!</h1>
      </div>
      <div class="box-1">
        <p class="align-center p-3">
          <img src="/images/haffner-page-logos.png" class="m-a full-width" style="max-width: 1000px;">
        </p>
        <p class="align-center mb-6">
          <a class="btn-primary _lg" @click.stop.prevent="enquiry_box_open = true">
            Make Enquiry
          </a>
        </p>
        <p class="align-center">
          Get 2 free service visits a year, across Haffner, Fom and Graf Synergy machines, to keep your machines in optimal condition.
        </p>
        <p class="align-center">
          The best way to increase the longevity of your machines starts with regular check-ups. Use our new partnership with Haffner to get you sorted.
        </p>
      </div>
      <div class="overlapping-image">
        <img src="/images/offers-and-promotions-haffner-two-machine.png">
      </div>
    </div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Haffner Offer Enquiry</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            <p>Please enter details of your enquiry below.</p>
            <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label>Please select the material:</label>
            <label>
              <input
                type="radio"
                v-model="selected_option"
                value="PVC-U"
              /> PVC-U
            </label>
            <label>
              <input
                type="radio"
                v-model="selected_option"
                value="Aluminium"
              /> Aluminium
            </label>
            <div v-if="show_error" class="txt-danger">
              Please select an option.
            </div>
          </div>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiry">
            Send
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['logged_in_user'],
  data() {
    return {
      enquiry_box_open: false,
      enquiry_message: 'I would like some more information on the Haffner Offer',
      sending: false,
      selected_option: '',
      show_error: false,
    };
  },
  methods: {
    sendEnquiry() {
      if (!this.selected_option) {
        this.show_error = true;
        return;
      }
      this.show_error = false;
      this.enquiry_box_open = false;
      this.sending = true;
      axios.post('/enquiry/send', {
        enquiry_type_id: 54,
        message: `${this.enquiry_message} - Selected material: ${this.selected_option}`,
      }).then((response) => {
        gtag('event', 'enquiry_made', {
          event_category: 'enquiries',
          event_label: 'Haffner offer enquiry',
          value: 'Haffner offer enquiry',
        });

        this.sending = false;
        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Thank you! We will respond in the next 48h hours. You will be sent a notification when you receive a reply.',
        });
      });
    },
  },
};
</script>
